import { Select } from 'components/ui/base/select/Select';
import styled, { createGlobalStyle } from 'styled-components';
import { colors } from 'theme';

export const GlobalSelectStyles = createGlobalStyle`
    .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        background-color: var(--gray-4) !important;
    }


   /* Hovered / active option */
  .ant-select-dropdown
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: var(--gray-2) !important;
  }
`;

const SELECT_HORIZONTAL_PADDING = 12;

export const StyledSelect = styled(Select)`
    width: 100%;
    display: flex;
    align-items: center;

    &.ant-select-show-search.ant-select > .ant-select-selector {
        padding: 0 ${SELECT_HORIZONTAL_PADDING}px;
        font-size: 14px;
        line-height: 24px;
    }

    &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        border-color: var(--brand-6);
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
        display: flex;
        align-items: center;
    }

    &.ant-select-focused .ant-select-selector {
        border-color: 1px solid var(--brand-6) !important;
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1) !important;
        outline: none !important;
    }

    &&.ant-select .ant-select-selector,
    &&.ant-select-show-search .ant-select-selector {
        border-radius: 6px;
    }

    &.ant-select-focused.ant-select-status-error .ant-select-selector {
        border-color: var(--error-normal) !important;
        box-shadow: var(--error-box-shadow) !important;
    }

    &.ant-select .ant-select-selector {
        width: 100%;
    }

    /* Remove the extra padding when we're in multiple mode */
    &.ant-select-multiple .ant-select-selector {
        padding-left: calc(${SELECT_HORIZONTAL_PADDING}px - 2px) !important;
    }

    /* remove left offset when search activates */
    &.ant-select-multiple .ant-select-selection-overflow {
        padding-left: 0 !important;
        margin-left: 0 !important;
    }

    /* hidden search input container */
    &.ant-select-multiple .ant-select-selection-search {
        margin-inline-start: 0 !important;
        height: 24px;
        display: flex;
        align-items: center;
    }

    &.ant-select-multiple .ant-select-selection-search-input {
        height: 24px;
        margin-left: 0 !important;
    }

    /* remove invisible 1px spacer causing left padding */
    &.ant-select-multiple .ant-select-selection-search::before {
        width: 0 !important;
    }

    /* tag / chip sizing to match line-height */
    &.ant-select-multiple .ant-select-selection-item {
        height: 24px;
        line-height: 22px;
        margin-top: 1px;
        margin-bottom: 1px;
        display: flex;
        align-items: center;
    }

    /* prevent focus from changing vertical size */
    &.ant-select-multiple.ant-select-focused .ant-select-selector {
        padding-top: 1px !important;
        padding-bottom: 1px !important;
    }
`;

export const NewStyledSelect = styled(Select)`
    display: inline-flex;
    align-items: center;

    * {
        border-radius: 6px !important;
    }

    &.ant-select-show-search.ant-select > .ant-select-selector {
        border-radius: 6px;
        height: 32px;
        padding: 0 12px;
        font-size: 14px;
        line-height: 24px;
    }

    // &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    //     border-color: var(--brand-6);
    // }
    //
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
        display: flex;
        align-items: center;
    }

    :global(.ant-select-item-option-selected) {
        background-color: ${colors.brand6} !important;
    }

    &.ant-select-focused .ant-select-selector {
        border-color: 1px solid ${colors.brand6} !important;
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1) !important;
        outline: none !important;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const RefWrapper = styled.span`
    border-radius: 6px;
    background-color: var(--gray-2);
    font-size: 1.4rem;
    line-height: 2.2rem;
    display: inline-block;
    min-width: 4rem;
    text-align: center;
`;
